import { Select } from '@doordash/component-fields';
import Toggle from '@doordash/component-toggle';
import { InlineChildren } from '@doordash/design-language';
import * as React from 'react';
import { BUDGET_DAYS_NAMES, BUDGET_DAYS_SELECT_VALUE_CUSTOM, daysSelectOptions, getDaysList, } from '../budget_helper';
import { InputContainer } from './budget_form_styles';
import { BudgetModalTestId } from '../../../testId';
export var BudgetDaysSelector = function (_a) {
    var values = _a.values, errors = _a.errors, setFieldValue = _a.setFieldValue;
    return (React.createElement(React.Fragment, null,
        React.createElement(InputContainer, { size: "large" },
            React.createElement(Select, { autoComplete: "off", label: "Days employees can order", "data-testid": BudgetModalTestId.DaysSelector, onChange: function (value) {
                    setFieldValue('budgetDaysSelect', value);
                    setFieldValue('budgetDaysList', getDaysList(value));
                }, options: daysSelectOptions.map(function (option) { return ({
                    name: option.label,
                    value: option.value,
                }); }), error: errors.budgetDaysList, value: values.budgetDaysSelect })),
        values.budgetDaysSelect === BUDGET_DAYS_SELECT_VALUE_CUSTOM ? (React.createElement(InlineChildren, { size: InlineChildren.Sizes.XSmall }, BUDGET_DAYS_NAMES.map(function (day, index) {
            var selectedDaysList = values.budgetDaysList;
            var selectDay = (index + 1).toString();
            return (React.createElement(Toggle, { label: day, onChange: function (value) {
                    if (value) {
                        selectedDaysList.push(selectDay);
                    }
                    else {
                        var selectDayIndex = selectedDaysList.indexOf(selectDay);
                        if (selectDayIndex > -1) {
                            selectedDaysList.splice(selectDayIndex, 1);
                        }
                    }
                    setFieldValue('budgetDaysList', selectedDaysList);
                }, type: Toggle.Types.Circle, isSelected: selectedDaysList.includes(selectDay), key: "budgetDaysList-" + index, size: Toggle.Sizes.Large }));
        }))) : null));
};
export default BudgetDaysSelector;
